import { Box } from '@mui/material';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { UIDefinitionProps } from './types';

export const UIDefinitionList: FC<UIDefinitionProps> = ({
  term,
  description,
  sx,
  descriptionSize,
  showDot = true,
  showEmptyPlaceholder = true,
  termSx,
  descriptionSx,
  className,
}) => {
  const { t } = useTranslation();
  return (
    <Box
      component='dl'
      sx={{
        flex: 1,
        ...sx,
      }}
      className={className}
    >
      <Box
        component='dt'
        sx={{
          fontSize: '1.4rem',
          fontWeight: 500,
          color: 'rgba(11, 19, 112, .5)',
          ...termSx,
        }}
      >
        {term}
        {showDot && ':'}
      </Box>
      <Box
        component='dd'
        sx={{
          fontSize: descriptionSize === 'medium' ? '1.7rem' : '1.4rem',
          fontWeight: 500,
          fontFamily: 'Manrope, sans-serif',
          m: 0,
          ...descriptionSx,
        }}
      >
        {description ? description : showEmptyPlaceholder ? t('no_data') : ''}
      </Box>
    </Box>
  );
};
